// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1GUcN","footer":"Form_footer__1qAfJ"};